import type { FC, ImgHTMLAttributes } from 'react';

const DEFAULT_WIDTHS = [512, 1080, 2048];

interface ImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'srcSet'> {
  src: string;
  alt: string;
  widths?: number[];
  lazy?: boolean;
}

function buildSrcSet(src: string, widths: number[]): string {
  const lastDot = src.lastIndexOf('.');
  if (lastDot === -1) return '';
  const base = src.substring(0, lastDot);
  return widths
    .map((w, i) => `${base}-${w}w.webp ${i + 1}x`)
    .join(', ');
}

export const Image: FC<ImageProps> = ({
  src,
  alt,
  widths = DEFAULT_WIDTHS,
  lazy = true,
  ...imgProps
}) => {
  return (
    <img
      src={src}
      srcSet={buildSrcSet(src, widths)}
      alt={alt}
      loading={lazy ? 'lazy' : undefined}
      {...imgProps}
    />
  );
};
